export class Deactivate {
  type: 'SUCCESS' = 'SUCCESS';

  static path = '/api/careRecipient/deactivate';
}
